import { authenticationParameters, b2cPolicies } from "./authConfig";

export const signUpSignInFlowRequest = {
  authority: b2cPolicies.authorities.signUpSignIn.authority,
  scopes: authenticationParameters.scopes,
  extraQueryParameters: {
    campaignId: window.location.hostname
  }
};